import { AutoComplete, DatePicker, Form, Input, Select } from "antd";
import React, { createRef, useEffect, useRef, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import AddButton from "../../../../Componets/Buttons/add";
import { select_search } from "../../../../Controllers/Global";
import Error from "../../../../Componets/Error";
import Modalcomponent from "../../../../Componets/Modal";
import { get_product } from "../../../../Controllers/Products/Products";
import TextArea from "antd/es/input/TextArea";
import UserCurrency from "../../../../Componets/UserCurrency";

const DeliveryNoteTable = React.forwardRef((props, focus) => {
  const {
    details,
    setDetails,
    totals,
    setTotals,
    note,
    setNote,
    salesOrderPending,
    setsalesOrderPending,
  } = props;

  console.log("details", props);

  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [selectedModalData, setSelectedModalData] = useState();

  const normalizedSalesOrder = Array.isArray(salesOrderPending)
    ? salesOrderPending
    : salesOrderPending?.details
      ? salesOrderPending.details
      : salesOrderPending;

  const handleSearch = async (e, index) => {
    let data = [...details];
    const select = {
      api: "get-all-products",
      search: e,
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value) => {
        options?.push({
          value: value?._id,
          label: (
            <div>
              <div>{value?.name}</div>
              <div>
                <span>
                  <UserCurrency /> {value?.sale_price?.toFixed(3) || "0.000"}
                </span>
              </div>
            </div>
          ),
        });
      });

      data[index].options = options;
      setDetails(data);
    } else {
      toast?.error(search?.message);
    }
  };

  const handleModal = (modaldata) => {
    let data = [...details];

    let product = selectedModalData;
    let index = selectedModalData?.index;

    let product_description = null;
    let product_name = "";
    let product_unit = "";
    let product_unit_name = "";
    let product_conversion = 0;
    let product_unit_details = [];
    let sale_price = 0;

    if (product?.data?._id == modaldata) {
      product_description = product?.data?._id;
      product_name = product?.data?.name;
      product_unit = modaldata;
      product_unit_name = product?.data?.unit?.name;
      sale_price = product?.data?.sale_price;

      if (product?.data?.product_units_details?.length > 0) {
        product?.data?.product_units_details?.map((value) => {
          product_unit_details?.push({
            ...value,
            name: value?.name?.name,
            price_per_unit: 0,
            sale_price: value?.sale_price,
            wholesale_price: value?.wholesale_price,
            unit_quantity: 0,
            unit_delivered: 0,
          });
        });
      }
    } else {
      let selected_unit = "";
      let unit_ids = [];

      if (product?.data?.product_units_details?.length > 0) {
        product?.data?.product_units_details?.map((value) => {
          unit_ids?.push(value?._id);
        });
      }

      if (unit_ids?.includes(modaldata)) {
        selected_unit =
          product?.data?.product_units_details?.[unit_ids?.indexOf(modaldata)];
      }

      product_description = product?.data?._id;
      product_name = product?.data?.name;
      product_unit = modaldata;
      product_unit_name = selected_unit?.name?.name;
      product_conversion = selected_unit?.conversion;
      sale_price = selected_unit?.sale_price;
    }

    data[index].description = product_description;
    data[index].name = product_name;
    data[index].unit = product_unit;
    data[index].unit_name = product_unit_name;
    data[index].quantity = "";
    data[index].conversion = product_conversion;
    data[index].unit_details_options = product_unit_details;
    data[index].sale_price = sale_price;

    setDetails(data);
    setModalData();
    setSelectedModalData();
    focus.current[`quantity${index}`].current.focus();
  };

  const handleDescription = async (e, index) => {
    let data = [...details];

    if (e) {
      let params = {
        id: e,
      };

      const product = await get_product(params);

      if (product?.status) {
        if (product?.data?.product_units_details?.length > 0) {
          setOpen(true);
          let modaldata = [
            {
              ...product?.data,
              name: product?.data?.unit,
            },
          ];

          product?.data?.product_units_details?.map((v) => {
            modaldata?.push(v);
          });

          setModalData(modaldata);
          setSelectedModalData({ ...product, index: index });
        } else {
          let product_description = product?.data?._id;
          let product_name = product?.data?.name;
          let product_unit = product?.data?._id;
          let product_unit_name = product?.data?.product_units_details?.name;
          let product_sale_price = product?.data?.wholesale_price
            ? product?.data?.wholesale_price
            : product?.data?.sale_price;

          let product_unit_details = [];
          if (product?.data?.product_unit_details?.length > 0) {
            product?.data?.product_unit_details?.map((value) => {
              product_unit_details?.push({
                ...value,
                name: value?.name?.name,
                price_per_unit: 0,
                sale_price: "",
                unit_quantity: 0,
                unit_delivered: 0,
              });
            });
          }

          data[index].description = product_description;
          data[index].name = product_name;
          data[index].unit = product_unit;
          data[index].unit_name = product_unit_name;
          data[index].sale_price = product_sale_price;
          data[index].quantity = "";
          data[index].unit_details_options = product_unit_details;

          setDetails(data);
          focus.current[`quantity${index}`].current.focus();
        }
      } else {
        toast?.error("Product not found");
      }
    } else {
      data[index].id = "";
      data[index].description = null;
      data[index].name = "";
      data[index].unit = "";
      data[index].unit_name = "";
      data[index].unit_details_options = null;
      data[index].quantity = "";
      data[index].conversion = 0;
      data[index].sale_price = "";
      data[index].total = 0;
      setDetails(data);
    }
  };

  const handleTotal = async (e, index, key) => {
    let name = key ? key : e?.target?.name;
    let value = e?.target?.value;

    // Get available stock for this product
    if (name === "quantity" && value) {
      // You'll need to fetch available stock from backend
      // For now, use the max_quantity from sales order pending
      const maxAvailable = details[index]?.max_quantity || 0;

      if (value < 0) {
        toast.error("Quantity cannot be negative");
        return;
      }

      if (value > maxAvailable) {
        toast.error(
          `Quantity cannot exceed pending quantity (${maxAvailable})`,
        );
        return;
      }
    }

    let data = [...details];
    let data_sale_price = data[index]?.sale_price ? data[index]?.sale_price : 0;
    let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;

    let item_sale_price = name === "sale_price" ? value : data_sale_price;
    let quantity = name === "quantity" ? value : data_quantity;

    let sale_price = parseFloat(item_sale_price);
    let total = parseFloat(sale_price) * parseFloat(quantity ? quantity : 0);
    let price_per_unit =
      parseFloat(total ? total : 0) / parseFloat(quantity ? quantity : 0);

    let unit_details_options = [];
    if (data?.[index]?.unit_details_options?.length > 0) {
      data?.[index]?.unit_details_options?.map((v) => {
        let total_quantity = parseFloat(quantity || 0);

        unit_details_options?.push({
          ...v,
          price_per_unit: price_per_unit
            ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
            : 0,
          unit_quantity: quantity
            ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
            : 0,
          unit_delivered: 0,
        });
      });
    }

    data[index][name] = value;
    data[index].unit_details_options = unit_details_options;
    data[index].total = total ? total : 0;
    data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

    let grandtotal = data?.reduce(
      (acc, currentValue) => parseFloat(acc) + parseFloat(currentValue?.total),
      0,
    );
    totals.total = grandtotal;

    setDetails(data);
    setTotals({ ...totals });
  };

  const handleRemove = (index) => {
    let data = [...details];
    data?.splice(index, 1);
    setDetails(data);

    let grandtotal = data?.reduce(
      (acc, currentValue) => parseFloat(acc) + parseFloat(currentValue?.total),
      0,
    );
    totals.total = grandtotal;
    setTotals({ ...totals });
  };

  const handleAdd = () => {
    if (
      !salesOrderPending ||
      !salesOrderPending.details ||
      salesOrderPending.details.length === 0
    ) {
      toast.error("No pending items available to add");
      return;
    }

    setDetails((prevDetails) => [
      ...prevDetails,
      {
        id: "",
        sales_order_detail: null,
        description: null,
        name: "",
        unit: "",
        unit_name: "",
        unit_details_options: null,
        quantity: "",
        sale_price: salesOrderPending?.sale_price || "",
        total: 0,
      },
    ]);

    setTimeout(() => {
      focus.current[`description${details?.length}`]?.current?.focus();
    }, 100);
  };

  const handleNote = (e) => {
    setNote(e);
  };

  useEffect(() => {
    if (normalizedSalesOrder?.length) {
      const mappedDetails = normalizedSalesOrder.map((item) => ({
        id: item.id ? item.id : "",
        sales_order_detail: item._id ? item._id : item.sales_order_detail._id,
        description: item.description,
        name: item.name,
        unit: item.unit,
        unit_name: item.unit_name,
        unit_details_options: null,
        quantity: item.quantity ? item.quantity : "",
        sale_price: item.sale_price || "",
        max_quantity: item.pending_quantity
          ? item.pending_quantity
          : item.sales_order_detail.quantity
            ? item.sales_order_detail.quantity
            : 0,
        original_quantity: item.original_quantity
          ? item.original_quantity
          : item.sales_order_detail.quantity
            ? item.sales_order_detail.quantity
            : 0,
        total:
          parseFloat(item.quantity || 0) * parseFloat(item.sale_price || 0),
      }));

      const grandTotal = mappedDetails.reduce(
        (sum, item) => sum + parseFloat(item.total || 0),
        0,
      );

      setDetails(mappedDetails);
      setTotals((prev) => ({
        ...prev,
        total: grandTotal,
      }));
    }
  }, [salesOrderPending]);

  return (
    <div className="overflow-x-auto">
      <Modalcomponent
        open={open}
        setOpen={setOpen}
        modalData={modalData}
        setModalData={setModalData}
        selectedModalData={selectedModalData}
        setSelectedModalData={setSelectedModalData}
        handleModal={handleModal}
      />
      <table className="w-[100%]">
        <thead>
          <tr>
            <td className="border p-4 text-black">S.NO</td>
            <td className="border p-4 text-black">DESCRIPTION</td>
            <td className="border p-4 text-black">UNIT</td>
            <td className="border p-4 text-black">SO QUANTITY</td>
            <td className="border p-4 text-black">PENDING</td>
            <td className="border p-4 text-black">DELIVERING</td>
            <td className="border p-4 text-black">SALE PRICE</td>
            <td className="border p-4 text-black">TOTAL</td>
            <td className="border p-4 text-black">DELETE</td>
          </tr>
        </thead>
        <tbody>
          {details?.map((value, index) => {
            focus.current[`description${index}`] = createRef();
            focus.current[`sale_price${index}`] = createRef();
            focus.current[`quantity${index}`] = createRef();
            return (
              <React.Fragment key={index}>
                <tr>
                  <td className="border p-4 text-center text-gray-700">
                    {index + 1}
                  </td>
                  <td className="border p-4">
                    <div className="pt-2">
                      <div>
                        {value?.description ? (
                          <div className="w-[300px]">
                            <div className="text-xs text-gray-900">
                              {value?.name}
                            </div>
                            <div className="text-xs text-gray-500">
                              Max: {value?.max_quantity || 0}
                            </div>
                          </div>
                        ) : (
                          <div>
                            <Select
                              className="w-[300px] text-regular"
                              name="description"
                              ref={focus.current[`description${index}`]}
                              placeholder="Select Product"
                              allowClear={true}
                              showSearch={true}
                              filterOption={false}
                              value={value?.description}
                              options={value?.options}
                              onSearch={(e) => handleSearch(e, index)}
                              onFocus={(e) => handleSearch("", index)}
                              onClick={(e) => handleSearch("", index)}
                              onChange={(e) => handleDescription(e, index)}
                              autoComplete="off"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <Error id={`description${index}`} />
                  </td>
                  <td className="border p-4 text-center">
                    <div>{value?.unit_name}</div>
                  </td>
                  <td className="border p-4 text-center">
                    <div>{value?.original_quantity || 0}</div>
                  </td>
                  <td className="border p-4 text-center">
                    <div className="text-orange-600 font-bold">
                      {value?.max_quantity || 0}
                    </div>
                  </td>
                  <td className="border p-4">
                    <div className="">
                      <Input
                        type="number"
                        className="w-full text-regular pt-2"
                        name="quantity"
                        ref={focus.current[`quantity${index}`]}
                        placeholder="Delivering Quantity"
                        value={value?.quantity}
                        onChange={(e) => handleTotal(e, index)}
                        autoComplete="off"
                      />
                      <div>
                        <Error id={`quantity${index}`} />
                      </div>
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    <div>
                      <Input
                        type="number"
                        className="w-[120px] text-regular"
                        name="sale_price"
                        ref={focus.current[`sale_price${index}`]}
                        placeholder="Sale price"
                        value={value?.sale_price}
                        onChange={(e) => handleTotal(e, index, "sale_price")}
                        autoComplete="off"
                      />
                      <Error id={`sale_price${index}`} />
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    {value?.total?.toFixed?.(3) || "0.000"}
                  </td>
                  <td className="border p-4 text-center">
                    <button
                      type="button"
                      className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                      onClick={() => handleRemove(index)}
                    >
                      <DeleteOutlined />
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td className="border p-4" rowSpan={2} colSpan={4}></td>
            <td className="border p-4" rowSpan={2} colSpan={2}>
              <div className="text-center">
                <AddButton
                  className={"form-save-button w-full h-full text-center"}
                  onClick={handleAdd}
                  disabled={!salesOrderPending}
                />
              </div>
            </td>
          </tr>
          <tr>
            <td className="border p-4 text-black text-medium">TOTAL</td>
            <td className="border p-4 text-black text-medium">
              {parseFloat(totals?.total || 0)?.toFixed(3)}
            </td>
          </tr>
        </tfoot>
      </table>
      {note !== undefined && (
        <div className="mt-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Note
          </label>
          <TextArea
            rows={3}
            value={note}
            onChange={handleNote}
            placeholder="Add a note to this delivery note..."
          />
        </div>
      )}
    </div>
  );
});

export default DeliveryNoteTable;
